import React, { useState } from "react";
import { FaEdit, FaEye, FaTrash } from "react-icons/fa";
import { useSelector } from "react-redux";
import { TD } from "styled/table";
import { BiCloudDownload } from "react-icons/bi";
import checkPermission from "utils/checkPermission";
import permissions from "utils/permissionConstants";
import EditVehicle from "./editVehicle";
import DeleteVehicle from "./deleteVehicle";
import CreateDeEnrollment from "components/vehicle-deenrollment/CreateDeEnrollment";
import EditAgreement from "./EditAgreement";
import { IoMdSettings } from "react-icons/io";
import ViewAgreement from "./ViewAgreement";

const ViewVehicleList = ({ getData, page, vehicle, index }) => {
  const [showEditModel, setShowEditModel] = useState(false);
  const [showDeleteModel, setShowDeleteModel] = useState(false);
  const [showDeEnrollModal, setShowDeEnrollModal] = useState(false);
  const[showAgreementModel,setShowAgreementModel]=useState(false);
  const[showAgreement,setShowAgreement]=useState(false);
  const [selectedVehicleForEdit, setSelectedVehicleForEdit] = useState(null);
  const [selectedVehicleForDelete, setSelectedVehicleForDelete] = useState(null);
  const [selectedVehicleForDeEnroll, setSelectedVehicleForDeEnroll] = useState(null);
  const [selectedVehicleForAgreement, setSelectedVehicleForAgreement] = useState(null);
  const[selectedAgreement,setSelectedAgreement]=useState(null);

  console.log('selectedAgreement--',selectedAgreement);

  const fetchFile = async (url) => {
    const originalImage = url;
    const image = await fetch(originalImage);
    const nameSplit = originalImage.split("/");
    const duplicateName = nameSplit.pop();

    const imageBlog = await image.blob();
    const imageURL = URL.createObjectURL(imageBlog);
    const link = document.createElement("a");
    link.href = imageURL;
    link.download = "" + duplicateName + "";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  const currentUser = useSelector((state) => state.user.currentUser);

  console.log('vehicle--',vehicle); 
  
  return (
    <tr key={vehicle._id} className={`${index % 2 !== 0 && "bg-gray-100"}`}>
      <TD>{(page-1)*100 + index + 1}</TD>
      <TD>{vehicle.registrationNumber}</TD>
      <TD>
        {vehicle.fitmentDate ?
          // ? new Date(vehicle.fitmentDate).toLocaleDateString("en-GB")
          vehicle.fitmentDate
        : ""}
      </TD>
      <TD>
        {vehicle.lastInspectionDate ?
          // ? new Date(vehicle.lastInspectionDate).toLocaleDateString("en-GB")
          vehicle.lastInspectionDate
        : ""}
      </TD>
      <TD>{vehicle?.fleet?.fleetName}</TD>
      <TD>{vehicle?.hub?.hubName}</TD>
      <TD>{vehicle.vehicleMake?.make}</TD>
      <TD>{vehicle.model?.name}</TD>
      <TD>{vehicle.registrationYear}</TD>
      <TD>{vehicle.configuration?.name}</TD>
      {/* <TD>{vehicle.engineNumber}</TD> */}
      <TD>{vehicle.contractType?.name}</TD>
      <TD>{vehicle.mechanicalCondition?.name}</TD>
      <TD>{vehicle.bodyType?.name}</TD>
      <TD>{vehicle.applicationType?.name}</TD>
      {/* <TD>{vehicle.vehicleCC}</TD>  
      <TD>{vehicle.GVW}</TD> */}

      {

       <TD className="flex">
          <div>
            <button
              onClick={() => {
                setSelectedVehicleForAgreement(vehicle);
                setShowAgreementModel(true);
              }}
              className= {`p-2 m-1 text-center ml-5 rounded-md ${vehicle.agreement ? "bg-blue-500 hover:bg-blue-600": "bg-yellow-500 hover:bg-yellow-600"} text-white`}
            >
              <IoMdSettings className="text-lg"/>
            </button>
            </div>
          {/* {vehicle?.agreement && (
            <BiCloudDownload
              className="w-8 h-8 text-green-500 hover:scale-105 cursor-pointer text-center"
              onClick={() => {
                fetchFile(vehicle?.agreement)
              }}
            />
          )}{" "} */}
        </TD>
}
      <TD>
      <div className= "flex">
      {checkPermission([permissions.manage_vehicles], currentUser) ? (
          <div>
            <button
              onClick={() => setShowEditModel(true)}
              className="p-2 m-1  rounded-md bg-green-500 hover:bg-green-600 text-white"
            >
              <FaEdit />
            </button>
            </div>
        ) : (
          <p>----</p>
        )}
        {checkPermission([permissions.delete_vehicle], currentUser) && (
          <button
          onClick={() => {
            setShowDeleteModel(true);
            console.log("hitting delete");
          }}
          className="p-2 m-1 rounded-md bg-red-500 hover:bg-red-600 text-white"
        >
          <FaTrash />
        </button>
        )}
        {checkPermission([permissions.manage_deenrollment], currentUser) ? (
              <button
                onClick={() => setShowDeEnrollModal(true)}
                disabled = {!vehicle.tyres?.length || vehicle.contractType?.name === "De-Enrolled"}
                className= {!vehicle.tyres?.length || vehicle.contractType?.name === "De-Enrolled" ? "p-2 m-1  rounded-md bg-gray-400 text-white font-semibold" : "p-2 m-1  rounded-md bg-green-500 hover:bg-green-600 text-white"}
              >
                De-Enrol
              </button>
          ) : (
            <p>----</p>
          )}

        </div>
        
      </TD>
      <TD>
      </TD>

          {showAgreement && (
          <ViewAgreement
            data={selectedVehicleForAgreement}
            selectedAgreement={selectedAgreement}
            handleClick={() => {
              setShowAgreement(false);
            }}
          />
    )}

      { showAgreementModel && (
        <EditAgreement
          data={selectedVehicleForAgreement}
          handleClick={() => setShowAgreementModel(false)}
          setShowAgreement={setShowAgreement}
          getData={getData}
          setSelectedAgreement={setSelectedAgreement}
        />
      )}
      {showEditModel && (
        <EditVehicle
          data={vehicle}
          handleClick={() => setShowEditModel(false)}
          getData={getData}
        />
      )}
      {showDeleteModel && (
        <DeleteVehicle
          data={vehicle}
          handleClick={() => setShowDeleteModel(false)}
        />
      )} 
      {showDeEnrollModal && (
        <CreateDeEnrollment getData = {getData} showDeEnrollModal = {showDeEnrollModal} handleClick={() => setShowDeEnrollModal(false)} vehicleId = {vehicle._id} />
      )}
    </tr>
  );
};

export default ViewVehicleList;
